module.exports = __webpack_public_path__ + "static/media/display-tray-dieline.0419d09b.svg";